var _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path5, _polygon6, _path6, _rect, _rect2, _rect3, _rect4, _polygon7, _polygon8, _polygon9, _path7, _path8, _polygon0, _path9, _path0, _path1, _path10, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _path11, _polygon17, _path12, _path13, _path14, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TurkmenistanCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M9,10.795v26.404c2.578,2.926,5.984,5.104,9.867,6.132V4.662C14.984,5.691,11.578,7.869,9,10.795z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M9,10.802C5.897,14.325,4,18.936,4,24c0,5.064,1.897,9.675,5,13.198V10.802z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M24,4c-1.778,0-3.492,0.255-5.133,0.69v38.62C20.508,43.745,22.222,44,24,44 c11.046,0,20-8.954,20-20C44,12.954,35.046,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M29.803,10.035c1.099,0.893,1.816,2.239,1.816,3.766c0,2.69-2.181,4.871-4.871,4.871 c-0.63,0-1.228-0.129-1.781-0.347c0.838,0.681,1.892,1.106,3.055,1.106c2.69,0,4.871-2.181,4.871-4.871 C32.894,12.499,31.61,10.747,29.803,10.035z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "24.775,14.505 25.347,14.896 25.907,14.486 25.712,15.152 26.274,15.557 25.581,15.577 25.369,16.238 25.136,15.584 24.443,15.587 24.992,15.163"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "24.79,12.077 25.362,12.468 25.922,12.058 25.727,12.724 26.289,13.129 25.596,13.149 25.385,13.809 25.151,13.156 24.458,13.159 25.007,12.735"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "22.316,13.291 22.889,13.682 23.448,13.272 23.253,13.938 23.816,14.343 23.123,14.363 22.911,15.024 22.678,14.37 21.984,14.373 22.533,13.949"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "27.218,10.787 27.791,11.178 28.35,10.768 28.155,11.434 28.718,11.839 28.024,11.859 27.813,12.52 27.579,11.866 26.886,11.869 27.435,11.446"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "24.79,9.573 25.362,9.964 25.922,9.554 25.727,10.22 26.289,10.625 25.596,10.645 25.385,11.306 25.151,10.652 24.458,10.655 25.007,10.232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M9.696,10.588l0.854,0.594v0.39l0.626,0.492h0.641l0.933,0.649h2.353l0.971-0.649h0.812l0.607-0.413 v-0.536l0.759-0.507V9.545l-0.759-0.539V8.483l-0.683-0.492h-0.746l-0.886-0.63l-2.183-0.019c-1.191,0.786-2.296,1.689-3.29,2.705 L9.696,10.588z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "14.085,12.714 15.103,12.714 16.075,12.065 16.887,12.065 17.494,11.651 17.494,11.116 18.253,10.608 18.253,9.886 14.085,9.886"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M14.047,9.886V7.351l-1.08-0.023c-1.127,0.744-2.145,1.55-3.096,2.558H14.047z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.542,
    height: 2.952,
    x: 10.224,
    y: 15.555,
    fill: "#43a047"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.863,
    height: 3.72,
    x: 11.078,
    y: 15.2,
    fill: "#ffc107"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.672,
    height: 4.546,
    x: 12.159,
    y: 14.787,
    fill: "#43a047"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.736,
    height: 5.146,
    x: 13.098,
    y: 14.492,
    fill: "#ffc107"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#43a047",
    points: "16.021,10.33 16.571,9.941 16.021,9.542 16.021,8.918 15.16,8.918 14.048,8.111 12.985,8.918 12.055,8.918 12.055,9.624 11.638,9.941 12.055,10.26 12.055,11.023 13.056,11.023 14.01,11.752 15.04,11.023 16.021,11.023"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "14.009,9.975 16.449,9.975 15.957,9.619 15.957,8.994 15.096,8.994 14.009,8.206 14.009,9.946 11.669,9.946 11.574,10.018 11.992,10.336 11.992,11.1 12.992,11.1 13.946,11.828 14.009,11.784"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "13.05,9.998 14.069,9.27 15.122,9.962 14.104,10.654"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M14.106,10.773l-1.236-0.77l1.196-0.855l1.236,0.812L14.106,10.773z M13.23,9.992l0.872,0.543 l0.841-0.572l-0.871-0.572L13.23,9.992z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M14.995,19.78h-2.002v-0.314h-0.968v-0.413h-1.062v-0.394h-0.854v-3.151h0.854v-0.394h1.062V14.7 h0.968v-0.314h2.002V14.7h0.968v0.414h1.062v0.394h0.854v3.151h-0.854v0.394h-1.062v0.413h-0.968V19.78z M13.192,19.581h1.602 v-0.314h0.968v-0.413h1.062V18.46h0.854v-2.753h-0.854v-0.394h-1.062v-0.414h-0.968v-0.314h-1.602v0.314h-0.968v0.414h-1.062 v0.394h-0.854v2.753h0.854v0.394h1.062v0.413h0.968V19.581z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "11.005,16.749 10.986,17.398 12.333,17.398 13.187,17.969 14.781,17.969 15.635,17.398 16.982,17.359 16.963,16.69 15.635,16.729 14.819,16.158 13.187,16.158 12.371,16.749"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M14.811,18.068h-1.654l-0.854-0.57h-1.42l0.025-0.849h1.431l0.816-0.591h1.695l0.026,0.018 l0.789,0.552l1.395-0.041l0.025,0.868l-1.418,0.042L14.811,18.068z M13.217,17.869h1.533l0.853-0.569l1.276-0.038l-0.013-0.47 l-1.261,0.037l-0.817-0.571h-1.568l-0.816,0.591h-1.301l-0.013,0.45h1.274L13.217,17.869z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M16.494,26.314h-5v-0.531h-0.759v-3.407h0.759v-0.531h5v0.531h0.759v3.407h-0.759V26.314z M11.693,26.115h4.6v-0.531h0.759v-3.009h-0.759v-0.531h-4.6v0.531h-0.759v3.009h0.759V26.115z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.966,24.867l-0.999-0.777l1.018-0.798l0.953,0.778L13.966,24.867z M13.292,24.09l0.671,0.521 l0.66-0.541l-0.641-0.522L13.292,24.09z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M12.696,25.804l-0.879-0.742l-0.04-1.942l0.879-0.763h0.037l2.734-0.04l0.727,0.666l-0.02,2.038 l-0.8,0.724h-0.037L12.696,25.804z M12.015,24.968l0.752,0.635l2.486-0.058l0.68-0.614l0.018-1.86l-0.602-0.553l-2.618,0.038 l-0.753,0.653L12.015,24.968z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#43a047",
    points: "13.984,28.459 13.301,28.97 11.081,28.97 11.005,29.64 10.398,29.64 10.398,30.309 9.715,30.309 9.696,31.785 10.436,31.785 10.436,32.513 11.1,32.513 11.1,33.202 13.225,33.202 13.984,33.733 14.743,33.202 16.906,33.202 16.963,32.513 17.57,32.513 17.608,31.883 18.234,31.883 18.215,30.348 17.608,30.348 17.57,29.758 16.963,29.758 17.001,28.99 14.743,28.99"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "13.984,29.226 12.978,30.112 14.003,30.978 14.99,30.073"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "12.295,30.25 11.29,31.135 12.314,32.001 13.301,31.096"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "15.749,30.25 14.743,31.135 15.767,32.001 16.754,31.096"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "12.978,34.961 10.436,36.279 10.436,38.405 12.732,39.841 15.103,39.841 17.532,38.562 17.532,36.338 15.084,34.98"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "13.984,31.175 12.978,32.06 14.003,32.926 14.99,32.021"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "10.474,37.342 14.022,37.362 14.022,34.921 13.092,34.961 10.55,36.279"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17.513,37.48 14.174,37.44 14.041,39.861 15.009,39.881 17.532,38.464"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M15.128,39.941h-2.426l-0.024-0.015l-2.343-1.466v-2.242l2.619-1.358l0.025,0.001l2.153,0.031 l2.5,1.388v2.343L15.128,39.941z M12.76,39.742h2.318l2.354-1.24v-2.104l-2.374-1.317l-2.056-0.019l-2.467,1.278v2.01 L12.76,39.742z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "13.984,35.905 12.94,36.574 12.523,36.614 12.485,38.149 12.978,38.208 13.984,38.897 15.027,38.247 15.464,38.228 15.445,36.574 15.084,36.574"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M13.981,39.016l-1.039-0.712l-0.56-0.066l0.042-1.715l0.481-0.046l1.076-0.69l0.053,0.033 l1.077,0.655h0.431l0.021,1.848l-0.507,0.023L13.981,39.016z M12.587,38.06l0.448,0.065l0.951,0.652l1.01-0.629l0.366-0.018 l-0.017-1.457h-0.29l-1.071-0.651l-1.036,0.651l-0.329,0.03L12.587,38.06z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M14.007,11.876l-0.985-0.753h-1.067V10.31L11.473,9.94l0.482-0.366V8.818h0.996l1.095-0.833 l1.146,0.833h0.928v0.673l0.622,0.45l-0.622,0.44v0.741h-1.049L14.007,11.876z M12.156,10.924h0.934l0.922,0.704l0.996-0.704 h0.913v-0.646l0.479-0.339l-0.479-0.347V9.018h-0.793l-1.078-0.782l-1.03,0.782h-0.863v0.656L11.803,9.94l0.353,0.27V10.924z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M13.984,33.855l-0.791-0.554H11v-0.689h-0.664v-0.728H9.595l0.021-1.676h0.682V29.54h0.618 l0.076-0.669h2.276l0.714-0.535l0.792,0.555h2.332l-0.038,0.768h0.596l0.038,0.59h0.612l0.021,1.734h-0.633l-0.038,0.63h-0.609 l-0.057,0.689h-2.224L13.984,33.855z M11.2,33.103h2.057l0.727,0.509l0.727-0.509h2.103l0.057-0.689h0.605l0.038-0.63h0.62 l-0.017-1.336h-0.603l-0.038-0.59h-0.618l0.038-0.768h-2.185l-0.725-0.508l-0.652,0.488H11.17l-0.076,0.669h-0.596v0.669H9.813 l-0.017,1.277h0.739v0.728H11.2V33.103z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 16.286,
    y: 36.699,
    fill: "#e53935"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 15.091,
    y: 35.754,
    fill: "#e53935"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 16.286,
    y: 37.909,
    fill: "#e53935"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 11.334,
    y: 36.699,
    fill: "#e53935"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 11.334,
    y: 37.909,
    fill: "#e53935"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 15.062,
    y: 38.766,
    fill: "#e53935"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 12.586,
    y: 35.754,
    fill: "#e53935"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.455,
    height: 0.354,
    x: 12.558,
    y: 38.766,
    fill: "#e53935"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "10.05,27.173 9.8,26.931 10.249,26.493 9,25.088 9,25.452 9.914,26.481 9.452,26.931 10.056,27.515 10.538,27.015 11.163,27.639 10.595,28.205 10.087,27.677 9.429,28.277 9.89,28.815 9,29.757 9,30.109 10.216,28.823 9.766,28.299 10.076,28.015 10.592,28.549 11.505,27.639 10.535,26.668"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "10.05,34.14 9.8,33.898 10.249,33.46 9,32.055 9,32.419 9.914,33.448 9.452,33.898 10.056,34.482 10.538,33.982 11.163,34.606 10.595,35.172 10.087,34.644 9.429,35.244 9.89,35.782 9,36.724 9,37.076 10.216,35.79 9.766,35.266 10.076,34.982 10.592,35.516 11.505,34.606 10.535,33.635"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "10.05,13.081 9.8,12.839 10.249,12.402 9,10.997 9,11.36 9.914,12.39 9.452,12.839 10.056,13.423 10.538,12.923 11.163,13.547 10.595,14.113 10.087,13.586 9.429,14.186 9.89,14.724 9,15.666 9,16.018 10.216,14.731 9.766,14.207 10.076,13.923 10.592,14.458 11.505,13.547 10.535,12.576"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "10.05,20.206 9.8,19.963 10.249,19.526 9,18.121 9,18.485 9.914,19.514 9.452,19.963 10.056,20.548 10.538,20.048 11.163,20.672 10.595,21.238 10.087,20.71 9.429,21.31 9.89,21.848 9,22.79 9,23.142 10.216,21.856 9.766,21.332 10.076,21.047 10.592,21.582 11.505,20.672 10.535,19.701"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "18.867,29.938 18.867,29.585 18.139,28.815 18.6,28.277 17.942,27.677 17.434,28.205 16.867,27.639 17.491,27.015 17.973,27.515 18.577,26.931 18.115,26.481 18.867,25.635 18.867,25.271 17.78,26.493 18.229,26.931 17.979,27.173 17.494,26.668 16.524,27.639 17.437,28.549 17.953,28.015 18.263,28.299 17.813,28.823"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "18.867,22.97 18.867,22.618 18.139,21.848 18.6,21.31 17.942,20.71 17.434,21.238 16.867,20.672 17.491,20.048 17.973,20.548 18.577,19.963 18.115,19.514 18.867,18.668 18.867,18.304 17.78,19.526 18.229,19.963 17.979,20.206 17.494,19.701 16.524,20.672 17.437,21.582 17.953,21.047 18.263,21.332 17.813,21.856"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17.494,12.576 16.524,13.547 17.437,14.458 17.953,13.923 18.263,14.207 17.813,14.731 18.867,15.846 18.867,15.494 18.139,14.724 18.6,14.186 17.942,13.586 17.434,14.113 16.867,13.547 17.491,12.923 17.973,13.423 18.577,12.839 18.115,12.39 18.867,11.543 18.867,11.18 17.78,12.402 18.229,12.839 17.979,13.081"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "17.494,6.034 16.524,6.978 17.437,7.865 17.953,7.344 18.263,7.621 17.813,8.131 18.867,9.216 18.867,8.873 18.139,8.124 18.6,7.6 17.942,7.016 17.434,7.529 16.867,6.978 17.491,6.371 17.973,6.858 18.577,6.289 18.115,5.852 18.867,5.028 18.867,4.674 17.78,5.864 18.229,6.289 17.979,6.525"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc107",
    points: "18.867,36.905 18.867,36.552 18.139,35.782 18.6,35.244 17.942,34.644 17.434,35.172 16.867,34.606 17.491,33.982 17.973,34.482 18.577,33.898 18.115,33.448 18.867,32.602 18.867,32.238 17.78,33.46 18.229,33.898 17.979,34.14 17.494,33.635 16.524,34.606 17.437,35.516 17.953,34.982 18.263,35.266 17.813,35.79"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M17.82,39.313c0.002,0.016,0.158,1.61-0.809,2.685c-0.168,0.187-0.367,0.34-0.582,0.474 c0.077,0.031,0.151,0.066,0.229,0.097c0.184-0.127,0.353-0.27,0.502-0.436c1.026-1.14,0.867-2.771,0.86-2.84L17.82,39.313z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M12.144,8.067l0.919-0.648l2.127,0.019l0.887,0.63h0.745l0.615,0.443v0.524l0.759,0.539v0.957 l-0.759,0.508v0.536L16.9,11.942h-0.812l-0.971,0.649h-2.292l-0.908-0.632l-0.026-0.018h-0.638l-0.561-0.441v-0.395l-0.853-0.593 l0.011-0.608c-0.067,0.067-0.138,0.13-0.204,0.197l-0.009,0.514l0.854,0.595v0.387l0.665,0.522l0.027,0.021h0.645l0.908,0.632 l0.026,0.018h2.415l0.971-0.649h0.812l0.677-0.461v-0.534l0.759-0.508V9.471l-0.759-0.539V8.409l-0.751-0.541h-0.746l-0.886-0.63 L13.13,7.221c-0.418,0.27-0.787,0.547-1.183,0.846L12.144,8.067z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TurkmenistanCircular);
export default __webpack_public_path__ + "static/media/icons8-turkmenistan-circular.369c2748a3b2bfc814b4e2373dd5cc6e.svg";
export { ForwardRef as ReactComponent };